export default class Accordion {
    constructor (elm) {
        this.isOpen = false;
        this.elm = elm;
        this.innerElm = elm.querySelector('.accordion__inner');
        this.expanderElm = elm.querySelector('.accordion__expander');

        elm.querySelectorAll('[data-accordion-toggle]').forEach((toggleElm) => {
            toggleElm.addEventListener('click', this.toggle.bind(this));
        });
    }

    toggle() {
        console.log('clicked');
        this.isOpen ? this.close() : this.open();
    }

    open() {
        this.isOpen = true;
        this.elm.classList.add('accordion--open');
        this.expanderElm.style.height = this.innerElm.getBoundingClientRect().height + 'px';
    }

    close() {
        this.isOpen = false;
        this.elm.classList.remove('accordion--open');
        this.expanderElm.style.height = 0;
    }
}
